import classes from "./Buttons.module.css";
const DarkBlueButton = (props) => {
    return (
        <button type="button" className={classes["dark-blue-button"]} {...props}>{props.children}</button>
    )
}
export default DarkBlueButton;
